/**
 * URLからロケール情報を取得するユーティリティ関数
 */
export const getLocaleLanguageCode = (): string => {
  // URLのパス名を取得
  const pathName = window.location.pathname;
  
  // パス名をスラッシュで分割し、最初のセグメントを取得
  const segments = pathName.split('/').filter(segment => segment.length > 0);
  return segments.length > 0 ? segments[0] : 'tw';
}